import React from "react";
import { Mail, MessageCircle, ChevronLeft, Ticket } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";

const SupportSection = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#080808] text-white selection:bg-primary-orange/30 flex flex-col">
      {/* DECORATION */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
        <div className="absolute top-[-10%] right-[-10%] w-[40%] h-[40%] bg-primary-orange/10 rounded-full blur-[120px] animate-glow" />
        <div className="absolute bottom-[-10%] left-[-10%] w-[40%] h-[40%] bg-primary-red/10 rounded-full blur-[120px] animate-glow" style={{ animationDelay: '2s' }} />
      </div>

      {/* NAVBAR */}
      <header className="fixed top-0 inset-x-0 z-50 bg-[#080808]/60 backdrop-blur-xl border-b border-white/5">
        <nav className="mx-auto max-w-7xl px-6 h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-10 h-10 bg-brand-gradient rounded-xl flex items-center justify-center shadow-lg shadow-orange-500/20 group-hover:scale-110 transition-transform">
              <Ticket className="text-white" size={20} />
            </div>
            <span className="font-black tracking-tighter text-2xl">PASSAR</span>
          </Link>
          <button
            onClick={() => navigate("/")}
            className="flex items-center gap-2 text-white/40 hover:text-white transition-colors group"
          >
            <ChevronLeft size={20} className="transition-transform group-hover:-translate-x-1" />
            <span className="font-bold text-sm">Volver</span>
          </button>
        </nav>
      </header>

      {/* CONTENT */}
      <main className="flex-1 relative z-10 flex flex-col items-center justify-center px-6 pt-32 pb-20">
        <div className="max-w-4xl w-full text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/5 border border-white/10 rounded-full mb-8 animate-fade-in-up">
            <span className="flex h-2 w-2 rounded-full bg-primary-orange animate-pulse" />
            <span className="text-[10px] font-black uppercase tracking-[2px] text-white/60">Centro de Ayuda</span>
          </div>

          <h1 className="text-5xl sm:text-6xl font-black tracking-tight mb-6 animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
            ¿Necesitás <span className="text-gradient">ayuda?</span>
          </h1>
          <p className="text-lg text-white/40 font-medium max-w-2xl mx-auto mb-16 animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            El equipo de soporte de PASSAR está disponible para asistirte con cualquier consulta sobre la plataforma, pagos o gestión de tus eventos.
          </p>

          <div className="grid sm:grid-cols-2 gap-8 animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
            {/* Email Card */}
            <a
              href="mailto:leonardodavidcba@gmail.com"
              className="bg-glass p-10 rounded-[40px] shadow-2xl group hover:-translate-y-2 transition-all duration-500 shine-effect text-left flex flex-col"
            >
              <div className="mb-8 p-6 bg-white/5 rounded-3xl w-fit text-primary-orange group-hover:scale-110 transition-all duration-500">
                <Mail size={32} />
              </div>
              <h3 className="text-2xl font-black tracking-tight mb-2">Soporte por Email</h3>
              <p className="text-white/40 font-medium leading-relaxed mb-6">
                Envianos un correo y te responderemos en menos de 24 horas hábiles.
              </p>
              <div className="mt-auto flex items-center gap-2 text-primary-orange font-bold group-hover:gap-4 transition-all">
                leonardodavidcba@gmail.com <ChevronLeft className="rotate-180" size={18} />
              </div>
            </a>

            {/* WhatsApp Card */}
            <a
              href="https://wa.me/5493517705231"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-glass p-10 rounded-[40px] shadow-2xl group hover:-translate-y-2 transition-all duration-500 shine-effect text-left flex flex-col"
            >
              <div className="mb-8 p-6 bg-white/5 rounded-3xl w-fit text-green-500 group-hover:scale-110 transition-all duration-500">
                <MessageCircle size={32} />
              </div>
              <h3 className="text-2xl font-black tracking-tight mb-2">WhatsApp Directo</h3>
              <p className="text-white/40 font-medium leading-relaxed mb-6">
                Chateá en vivo con nuestro equipo para una respuesta inmediata.
              </p>
              <div className="mt-auto flex items-center gap-2 text-green-500 font-bold group-hover:gap-4 transition-all">
                Abrir chat <ChevronLeft className="rotate-180" size={18} />
              </div>
            </a>
          </div>

          <div className="mt-16 p-8 bg-white/5 border border-white/5 rounded-3xl animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
            <p className="text-sm text-white/30 font-medium">
              ¿Sos cliente de un salón específico? Por favor, dirigite al soporte del mismo dentro de su página para consultas locales.
            </p>
          </div>
        </div>
      </main>

      {/* FOOTER */}
      <footer className="py-10 px-6 border-t border-white/5 relative z-10 text-center">
        <p className="text-[10px] font-black text-white/10 uppercase tracking-[4px]">
          © {new Date().getFullYear()} PASSAR • LM-INGENIERÍA
        </p>
      </footer>
    </div>
  );
};

export default SupportSection;